module.exports = __webpack_public_path__ + "static/media/ic-bifrost-logo.cd06c87f.svg";